import { createFileRoute } from "@tanstack/react-router";
import { useParams } from "@/lib/navigation";
import { MembershipTransferDetail } from "@/components/MembershipTransfers/Detail";

function RouteComponent() {
  const params = useParams();
  const id = params?.id as string;

  return <MembershipTransferDetail id={id} />;
}

export const Route = createFileRoute("/_authenticated/membership-transfers/$id/")({
  component: RouteComponent,
  staticData: { page: "deals" },
});
